(() => {
  const roots = document.querySelectorAll('[data-lantern-photo-uploads]');

  roots.forEach((root) => {
    if (root.dataset.initialized === 'true') return;

    const formId = root.dataset.productFormId;
    const form = document.getElementById(formId);
    if (!form) {
      const summary = root.querySelector('#lantern-upload-summary');
      if (summary) {
        summary.textContent = 'Photo uploads are still loading. Refresh the page if this message remains.';
      }
      return;
    }

    root.dataset.initialized = 'true';

    form.enctype = 'multipart/form-data';

    const fileInputs = Array.from(root.querySelectorAll('input[type="file"][data-lantern-photo]'));
    const authorization = root.querySelector('[data-photo-authorization]');
    const formComponent = form.closest('product-form-component');
    const validTypes = new Set(['image/jpeg', 'image/png']);
    const validExtensions = /\.(jpe?g|png)$/i;

    const getAddButtons = () =>
      Array.from(formComponent?.querySelectorAll('[name="add"], [ref="addToCartButton"]') || []);

    const allUploadsReady = () =>
      fileInputs.length === 4 &&
      fileInputs.every((input) => input.dataset.photoValid === 'true') &&
      authorization?.checked === true;

    const updateAddButtons = () => {
      const ready = allUploadsReady();
      const summary = root.querySelector('#lantern-upload-summary');

      getAddButtons().forEach((button) => {
        if (!ready) {
          button.classList.add('lantern-upload-locked');
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('aria-describedby', 'lantern-upload-summary');
        } else {
          button.classList.remove('lantern-upload-locked');
          button.removeAttribute('aria-disabled');
          button.removeAttribute('aria-describedby');
        }
      });

      if (summary) {
        summary.textContent = ready
          ? 'All four photos are ready and authorization is confirmed.'
          : 'Add to Cart is blocked until all four valid photographs and the authorization are provided.';
      }

      root.classList.toggle('lantern-uploads--ready', ready);
    };

    const showValidation = () => {
      fileInputs.forEach((input) => {
        if (!input.files?.length) {
          input.setCustomValidity('Please upload this required portrait or square JPG or PNG image.');
        }
      });

      if (authorization && !authorization.checked) {
        authorization.setCustomValidity('Please confirm that you have permission to reproduce these photographs.');
      }

      form.reportValidity();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const setFieldState = (input, state, message, previewUrl = '') => {
      const field = input.closest('[data-photo-field]');
      const status = field?.querySelector('[data-photo-status]');
      const preview = field?.querySelector('[data-photo-preview]');

      input.dataset.photoValid = state === 'valid' || state === 'warning' ? 'true' : 'false';
      field?.setAttribute('data-state', state);
      if (status) status.textContent = message;

      if (preview) {
        if (previewUrl) {
          preview.src = previewUrl;
          preview.hidden = false;
        } else {
          preview.removeAttribute('src');
          preview.hidden = true;
        }
      }

      updateAddButtons();
    };

    const validatePortraitImage = (input) => {
      const file = input.files?.[0];
      input.setCustomValidity('');

      if (!file) {
        setFieldState(input, 'empty', 'Required: portrait or square JPG or PNG.');
        return;
      }

      if (!validTypes.has(file.type) || !validExtensions.test(file.name)) {
        input.setCustomValidity('Please choose a JPG or PNG image.');
        setFieldState(input, 'invalid', 'JPG or PNG files only.');
        return;
      }

      setFieldState(input, 'checking', 'Checking image orientation…');
      const objectUrl = URL.createObjectURL(file);
      const image = new Image();

      image.onload = () => {
        if (image.naturalHeight < image.naturalWidth) {
          input.setCustomValidity('Please choose a portrait or square image. Landscape images cannot be used.');
          setFieldState(input, 'invalid', 'Landscape images cannot be used. Choose a portrait or square image.');
        } else if (image.naturalHeight === image.naturalWidth) {
          input.setCustomValidity('');
          setFieldState(
            input,
            'warning',
            `${file.name} — accepted. Portrait images work best; square images may require cropping.`,
            objectUrl
          );
        } else {
          input.setCustomValidity('');
          setFieldState(input, 'valid', `${file.name} — ready`, objectUrl);
        }
        URL.revokeObjectURL(objectUrl);
      };

      image.onerror = () => {
        input.setCustomValidity('This image could not be read. Please choose another JPG or PNG file.');
        setFieldState(input, 'invalid', 'Unable to read this image. Please choose another file.');
        URL.revokeObjectURL(objectUrl);
      };

      image.src = objectUrl;
    };

    fileInputs.forEach((input) => {
      input.dataset.photoValid = 'false';
      input.addEventListener('change', () => validatePortraitImage(input));
    });

    authorization?.addEventListener('change', updateAddButtons);

    formComponent?.addEventListener(
      'click',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const button = target?.closest('[name="add"], [ref="addToCartButton"]');
        if (!button || allUploadsReady()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        showValidation();
      },
      true
    );

    form.addEventListener(
      'submit',
      (event) => {
        if (allUploadsReady()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        showValidation();
      },
      true
    );

    authorization?.addEventListener('change', () => authorization.setCustomValidity(''));

    if (formComponent) {
      const observer = new MutationObserver(() => updateAddButtons());
      observer.observe(formComponent, { childList: true, subtree: true });
    }

    updateAddButtons();
  });
})();
